'use client';

import React, { useEffect, useRef } from 'react';

const faqs = [
  {
    q: 'How does billing work',
    a: 'Each rep is $3,499 per month, paid upfront at the start of the month. Qualified meetings carry a separate per-meeting fee that is set in your agreement before launch. There are no setup fees and no other charges.',
  },
  {
    q: 'What counts as a qualified meeting',
    a: 'The definition is written into your agreement before launch: company fits your ICP, contact meets the seniority bar we set together, a need was confirmed, and the meeting was held with your team. The per-meeting fee only applies to meetings that meet that written definition.',
  },
  {
    q: 'Why a per-meeting fee on top of the monthly rate',
    a: 'It keeps incentives aligned. The monthly rate covers your dedicated rep and the system behind them. The meeting fee means we win when you get real, qualified conversations, and the written definition means we cannot pad the count with weak ones.',
  },
  {
    q: 'What should I expect in the first 60 to 90 days',
    a: 'Weeks 1 to 2 are setup, data build, and training. Live outreach begins phone-first, and performance builds over the first 60 to 90 days as targeting and messaging tune against real conversations. We put this timeline in writing so month two never becomes a surprise.',
  },
  {
    q: 'Can I add or remove reps',
    a: 'Yes. Reps can be added as pipeline proves out, and the engagement is month to month with 30 days notice, so team size flexes with your needs.',
  },
  {
    q: 'Is there a contract minimum',
    a: 'No. Every engagement is month to month. We price for renewal, not lock-in.',
  },
];

export default function FaqSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    const els = sectionRef?.current?.querySelectorAll('.rev');
    els?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-16">
      <div className="max-w-[840px] mx-auto px-7">
        <div className="rev mb-13">
          <div className="eyebrow">Straight answers</div>
          <h2 className="heading-2 text-ink">Pricing questions</h2>
        </div>

        {faqs?.map((faq, i) => (
          <details
            key={faq?.q}
            className="rev faq-item"
            style={{ transitionDelay: `${i * 0.07}s` }}
          >
            <summary className="faq-q font-semibold text-[17px] cursor-pointer flex justify-between gap-5 text-ink" style={{ listStyle: 'none' }}>
              {faq?.q}
            </summary>
            <p className="mt-3 text-muted-text text-[15.5px] leading-relaxed">{faq?.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}